import { createTracker } from 'usage-tracker';
import { makeUuid } from 'usage-tracker-core/common/helpers';
let tracker;
const NAMESPACE = 'billing-portal';
export const initUsageTracker = () => {
  if (!tracker) {
    tracker = createTracker({
      standalone: true,
      allowUnauthed: true,
      isExternalHost: true,
      properties: {
        email: null,
        hubId: null,
        lang: null,
        deviceId: makeUuid()
      }
    });
  }
  return tracker;
};
export const trackPageView = subscreen => {
  if (!tracker) {
    initUsageTracker();
  }
  tracker.track(NAMESPACE, 'page viewed', {
    subscreen
  });
};
export const trackInteraction = (action, properties) => {
  if (!tracker) {
    initUsageTracker();
  }
  tracker.track(NAMESPACE, 'interaction', Object.assign({
    action
  }, properties));
};